import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "../../../lib/utils";

type CredentialParsePendingStateProps = {
  overlay?: boolean;
};

export const CredentialParsePendingState: React.FC<
  CredentialParsePendingStateProps
> = ({ overlay = false }) => (
  <div
    role="status"
    aria-live="polite"
    className={cn(
      "flex flex-col items-center justify-center gap-3 text-center",
      overlay
        ? "pointer-events-auto absolute inset-0 z-10 rounded-xl bg-card/95 px-6 py-10"
        : "min-h-72 rounded-xl border border-border bg-card px-6 py-16",
    )}
  >
    <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
    <p className="text-base font-semibold text-foreground">
      Reading this photo
    </p>
  </div>
);
